import { useEffect, useState } from "react";
import { toast } from "sonner";
import { UserPlus } from "lucide-react";
import { api, errMsg } from "@/lib/api";

const MODES = [
  ["approval", "Sign up + approval", "New stores sign up, then wait for you to approve them."],
  ["open", "Open sign-up", "New stores sign up and start using the studio at once."],
  ["closed", "Only I create stores", "Public sign-up is off; you add stores yourself."],
];

export default function SignupModeCard() {
  const [mode, setMode] = useState(null);
  useEffect(() => { api.get("/admin/settings").then((r) => setMode(r.data.signup_mode)); }, []);
  const choose = async (m) => {
    const prev = mode;
    setMode(m);
    try { await api.put("/admin/settings", { signup_mode: m }); toast.success("Sign-up setting saved"); } catch (e) { setMode(prev); toast.error(errMsg(e)); }
  };
  return (
    <section className="rounded-xl border border-slate-800 bg-slate-900/60 p-5" data-testid="signup-mode-card">
      <p className="font-heading font-bold flex items-center gap-2"><UserPlus size={16} className="text-amber-400" /> How new stores join</p>
      <div className="grid md:grid-cols-3 gap-3 mt-4">
        {MODES.map(([k, label, desc]) => (
          <button key={k} onClick={() => choose(k)} disabled={!mode} data-testid={`signup-mode-${k}`}
            className={`text-left rounded-lg border p-4 transition-colors ${mode === k ? "border-amber-400 bg-amber-500/10" : "border-slate-800 hover:border-slate-600"}`}>
            <p className={`text-sm font-semibold ${mode === k ? "text-amber-300" : "text-slate-200"}`}>{label}</p>
            <p className="text-xs text-slate-500 mt-1">{desc}</p>
          </button>
        ))}
      </div>
    </section>
  );
}
